<template>
  <div class="app-router">
    <h2 class="font-weight-bold pb-5">Voucher Toko</h2>

    <div class="d-block px-2 py-3">
      <v-expansion-panels
        v-model="panel"
        id="filter-vccard"
        tile
        accordion
        focusable
        class="accordion-filter d-none"
      >
        <v-expansion-panel>
          <v-expansion-panel-header
            class="text-uppercase font-weight-bold text-body-2 px-3 py-3 mt-5"
            >
            <div><v-icon>mdi-filter-outline</v-icon> Filter</div>
          </v-expansion-panel-header>

          <v-expansion-panel-content class="px-4 pt-4 pb-0 mt-2 border" outlined>
            <!-- <v-form>
              <v-row>
                <v-col cols="6" class="py-0">
                  <v-text-field
                    v-model="productNameFilter.value"
                    outlined
                    small
                    dense
                    hide-details
                    class="searchInput"
                    placeholder="cari nama produk atau SKU"
                  >
                    <div slot="append">
                      <v-btn
                        small
                        elevation="2"
                        color="success"
                      >
                        <v-icon center>
                          mdi-magnify
                        </v-icon>
                      </v-btn>
                    </div>
                  </v-text-field>
                </v-col>

                < !-- <v-col cols="6" class="py-0">
                  <v-select
                    v-model="productCategoryFilter.value"
                    :items="category"
                    item-text="voucher_category_name"
                    item-value="voucher_category_id"
                    placeholder="Pilih Kategori"
                    outlined
                    multiple
                    dense
                  ></v-select>
                </v-col> - >
              </v-row>

              <v-row>
                <v-col cols="6" class="py-0">
                  <v-row class="align-center">
                    <v-col cols="3" class="py-0">
                      Stok
                    </v-col>
                    <v-col cols="4" class="py-0">
                      <v-currency-field
                        v-model="productStockMinFilter.value"
                        outlined
                        small
                        dense
                        hide-details
                      ></v-currency-field>
                    </v-col>
                    <v-col cols="1" class="py-0">
                      -
                    </v-col>
                    <v-col cols="4" class="py-0">
                      <v-currency-field
                        v-model="productStockMaxFilter.value"
                        outlined
                        small
                        dense
                        hide-details
                      ></v-currency-field>
                    </v-col>
                  </v-row>
                </v-col>

                <v-col cols="6" class="py-0">
                  <v-row class="align-center">
                    <v-col cols="3" class="py-0">
                      Penjualan
                    </v-col>
                    <v-col cols="4" class="py-0">
                      <v-currency-field
                        v-model="productSoldMinFilter.value"
                        outlined
                        small
                        dense
                        hide-details
                      ></v-currency-field>
                    </v-col>
                    <v-col cols="1" class="py-0">
                      -
                    </v-col>
                    <v-col cols="4" class="py-0">
                      <v-currency-field
                        v-model="productSoldMaxFilter.value"
                        outlined
                        small
                        dense
                        hide-details
                      ></v-currency-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" class="text-right pb-0 pt-5 mt-3">
                  <v-btn
                    color="success"
                    elevation="2"
                    dark
                    class="mr-3"
                    width="140"
                    @click="cari"
                  >
                    <strong class="text-uppercase">Cari</strong>
                  </v-btn>

                  <v-btn
                    color="error"
                    elevation="2"
                    outlined
                    dark
                    width="140"
                    @click="resetFilter"
                  >
                    <strong class="text-uppercase">Reset</strong>
                  </v-btn>
                </v-col>
              </v-row>
            </v-form> -->
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <!-- <v-row class="my-0 align-center">
        <v-col cols="12" sm="6">
          <div class="text-subtitle-2 font-weight-bold">
            Jumlah Voucher Tersedia
            <v-chip
              small
              class="ma-2"
              :color="voucher_by_type.colorCount"
              outlined
            >
              {{ voucherList.pagination.total_data }}
            </v-chip>
          </div>
        </v-col>
        <v-col cols="12" sm="6" :class="(isMobile) ? 'text-left pt-0' : 'text-right'">
        </v-col>
      </v-row> -->

      <v-layout v-resize="onResize" column>
        <v-data-table
          ref="datatable"
          :server-items-length="voucherList.pagination.total_data"
          hide-default-footer
          v-model="selected"
          :loading="loading"
          :headers="headers"
          :items="voucherList.lists"
          :expanded.sync="expanded"
          single-expand
          item-key="voucher_code"
          show-expand
          class="elevation-1 border"
          :class="{mobile: isMobile}"
          id="product-table"
        >
          <template v-slot:header.voucher_code="{ header }">
            <span class="black--text font-weight-bold text-capitalize">{{ header.text }}</span>
          </template>
          <template v-slot:header.voucher_amount="{ header }">
            <span class="black--text font-weight-bold text-capitalize">{{ header.text }}</span>
          </template>
          <template v-slot:header.voucher_expired_date="{ header }">
            <span class="black--text font-weight-bold text-capitalize">{{ header.text }}</span>
          </template>
          <template v-slot:header.voucher_min_price="{ header }">
            <span class="black--text font-weight-bold text-capitalize">{{ header.text }}</span>
          </template>
          <template v-slot:header.voucher_use_trx_id="{ header }">
            <span class="black--text font-weight-bold text-capitalize">{{ header.text }}</span>
          </template>
          <template v-slot:header.voucher_status="{ header }">
            <span class="black--text font-weight-bold text-capitalize">{{ header.text }}</span>
          </template>

          <template v-slot:item.voucher_code="{ item }">
            <b style="color: #009303;">{{ item.voucher_code }}</b>
          </template>
          
          <template v-slot:item.voucher_expired_date="{ item }">
            {{ item.voucher_expired_date | tanggalIndo }}
          </template>

          <template v-slot:item.voucher_use_trx_id="{ item }">
            <template v-if="item.voucher_use_trx_id">
              <div class="d-flex flex-column">
                <small class="d-block mb-1"><b>{{ item.trx_code | emptyData }}</b></small>
                <small><v-icon small dense class="mr-1">mdi-calendar-check</v-icon>{{ item.voucher_use_datetime | tanggalIndo }}</small>
                <small><v-icon small dense class="mr-1">mdi-account-outline</v-icon>{{ item.buyer_name }}</small>
              </div>
            </template>
            <template v-else>
              {{ item.voucher_use_trx_id | emptyData }}
            </template>
          </template>

          <template v-slot:item.voucher_amount="{ item }">
            {{ item.voucher_amount | toRupiah }}
          </template>

          <template v-slot:item.voucher_min_price="{ item }">
            {{ item.voucher_min_price | toRupiah }}
          </template>

          <template v-slot:item.voucher_status="{ item }">
            <v-chip small class="font-weight-bold" v-if="item.voucher_status == 'Set'">{{ item.voucher_status}}</v-chip>
            <v-chip small color="error" class="font-weight-bold" v-else-if="item.voucher_status == 'Terpakai'">{{ item.voucher_status}}</v-chip>
            <v-chip small color="success" class="font-weight-bold" v-else>{{ item.voucher_status}}</v-chip>
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-row dense class="d-flex align-center justify-content-end my-2">
                <v-col cols="12" lg="6" class="text-right">Syarat Minimum Belanja</v-col>
                <v-col cols="12" lg="4" class="text-right">
                  <v-currency-field
                    v-model="item.voucher_min_price"
                    outlined
                    dense
                    suffix="Rp "
                    reverse
                    hide-details="auto"
                    class="text-right"
                  ></v-currency-field>
                </v-col>

                <v-col cols="12" lg="2" class="text-right">
                  <v-btn
                    color="primary"
                    elevation="1"
                    tile
                    dark
                    block
                    small
                    style="height: 40px; border-radius: 4px;"
                    :loading="processLoading"
                    @click="updateVoucherData(item)"
                  >
                    <span class="text-capitalize font-weight-medium white--text"><v-icon medium class="white--text darken-1 font-weight-normal mr-2">mdi-content-save-outline</v-icon>Simpan</span>
                  </v-btn>
                </v-col>
              </v-row>
            </td>
          </template>

          <template v-slot:no-data>
            <div class="d-flex flex-column align-center py-5 px-5">
              <v-img width="260" class="py-5 my-4" src="/assets/seller/belum-ada-barang.svg"></v-img>
              <div class="text-h6 black--text">Voucher tidak tersedia untuk saat ini.</div>
            </div>
          </template>
        </v-data-table>
      </v-layout>

      <v-pagination v-if="voucherList.pagination.total_page > 1 && voucherList.lists.length > 0" @input="updatePage" v-model="page" :length="voucherList.pagination.total_page" total-visible="7" circle class="d-flex justify-end no-button-focus py-2"></v-pagination>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
// import ModalDelete from '@/components/ModalDelete'

export default {
  components: {
    // ModalDelete
  },

  data() {
    return {
      loading: false,
      processLoading: false,
      page: 1,
      limit: 8,
      params: [],
      sort: {},
      sortBy: 'voucher_expired_date',
      sortDir: 'DESC',
      voucherData: [],

      panel: [0],

      voucherCodeFilter: {
        value: '',
        comparison: 'like',
        type: 'string',
        field: 'voucher_code',
      },
      productStockMinFilter: {
        value: '',
        comparison: '>',
        type: 'numeric',
        field: 'store_stock_quantity',
      },
      productStockMaxFilter: {
        value: '',
        comparison: '<',
        type: 'numeric',
        field: 'store_stock_quantity',
      },
      productSoldMinFilter: {
        value: '',
        comparison: '>',
        type: 'numeric',
        field: 'voucher_sold_count',
      },
      productSoldMaxFilter: {
        value: '',
        comparison: '<',
        type: 'numeric',
        field: 'voucher_sold_count',
      },

      filter: {
        search: '',
        categoryId: null,
        minStock: 0,
        maxStock: 0,
        minSold: 0,
        maxSold: 0
      },
      selected: [],
      expanded: [],
      headers: [
        {
          text: 'Kode Voucher',
          align: 'start',
          sortable: false,
          value: 'voucher_code',
          // width: '40%'
        },
        { text: 'Nilai', sortable: false, align: 'right', value: 'voucher_amount' },
        { text: 'Tgl. Expired',sortable: false, value: 'voucher_expired_date', align: 'left' },
        { text: 'Min. Belanja',sortable: false, value: 'voucher_min_price', align: 'right' },
        { text: 'Penggunaan', value: 'voucher_use_trx_id', sortable: false, align: 'left' },
        { text: 'Status',sortable: false, value: 'voucher_status', align: 'center' },
        { text: '', value: 'data-table-expand' }
      ],
      selectedItem: null,
      dialogReminderStock:false,
      isMobile: false,
    }
  },

  props:{
    type: String
  },

  computed: {
    ...mapState('voucherSeller', ['voucherList']),
    ...mapState('authSeller', ['isAuth', 'sellerData']),

    voucher_by_type() {
      let dataType = {
        title: 'Semua Produk',
        colorCount: 'green',
      }

      return dataType
    }
  },

  methods: {
    ...mapActions('voucherSeller', ['getVoucherList', 'updateVoucher']),

    getMinPriceVal(code) {
      if (code && this.voucherData.length > 0) {
        let voucher = this.voucherData.find((vc) => vc.voucher_code == code)
        return voucher.voucher_min_price
      } else {
        return 0
      }
    },

    async updateVoucherData(item) {
      this.processLoading = await true
      if (item !== undefined) {
        this.loading = await true
        await this.updateVoucher({
          voucher_min_price: item.voucher_min_price,
          voucher_code: item.voucher_code,
        }).then(() => {
          this.getVoucherList()
          setTimeout(() => {
            this.processLoading = false
            this.loading = false
          }, 1000);
        }).catch(() => {
          this.processLoading = false
          this.loading = false
        })
      }
    },

    async getVoucherLists() {
      this.loading = await true

      await this.getVoucherList(
        this.queryString({
          limit: this.limit,
          page: this.page,
          params: this.params,
          sort: this.sortBy,
          dir: this.sortDir,
        })
      ).then((res) => {
        this.voucherData = {...res.data}
        setTimeout(() => {
          this.$refs.datatable._data.expanded = false
          this.expanded = []
          this.loading = false
        }, 1000);
      }).catch(() => {
        this.loading = false
      })
      
    },

    cari() {
      this.params = []

      if (this.productNameFilter.value) this.params.push(this.productNameFilter)
      if (this.productCategoryFilter.value) this.params.push(this.productCategoryFilter)
      if (this.productStockMinFilter.value) this.params.push(this.productStockMinFilter)
      if (this.productStockMaxFilter.value) this.params.push(this.productStockMaxFilter)
      if (this.productSoldMinFilter.value) this.params.push(this.productSoldMinFilter)
      if (this.productSoldMaxFilter.value) this.params.push(this.productSoldMaxFilter)

      this.sortBy = this.sort.sortBy
      this.sortDir = this.sort.sortDir
      this.page = 1
      this.getVoucherList()
    },

    resetFilter() {
      this.productNameFilter.value = ''
      this.productCategoryFilter.value = ''
      this.productStockMinFilter.value = ''
      this.productStockMaxFilter.value = ''
      this.productSoldMinFilter.value = ''
      this.productSoldMaxFilter.value = ''
      this.cari()
    },
    async hapus(item) {
      this.selectedItem = await item
      this.$refs.ModalDelete.modalShow()
    },

    removeData() {
      this.removeProduct({id: this.selectedItem.voucher_id}).then( () => {
        this.page = 1
        this.getVoucherList()
      })
    },

    async openReminderDialog(item) {
      this.selectedItem = await item
      this.dialogReminderStock = true
    },

    addProduk() {
      this.$router.push({ path : '/seller/tambah-produk' })
    },
    updatePage(val) {
      this.page = val
      this.getVoucherLists()
    },

    onResize() {
      if (window.innerWidth < 769)
        this.isMobile = true;
      else
        this.isMobile = false;
    },
  },
  async created() {
    this.loading = await true
    await this.$store.dispatch('setPageTitle', 'Voucher Toko');
    this.getVoucherLists()
  }
}
</script>